import React, { useState } from 'react';
import { LineSteppedAreaChart, Widget } from 'features/command-center';
import { getActivityPlacementsHistory } from 'features/command-center/services';
import moment from 'moment';
import strings from 'strings';
import { additionalPeriodRanges } from 'UI/components/templates/SideFiltersLayout/filters';
import { DateFormats } from 'UI/constants/defaults';
import { createCustomStaticRanges, getYearToDate } from 'UI/utils';

import { DateRange } from '../../shared/InlineFilters/components/DateRange';

import { formatResponse } from './PlacementsTrends.utils';

const COPIES = strings.placements;
const defaultRange = getYearToDate();

export const PlacementsTrends = ({ requestParams = {} }) => {
  const [dateRange, setDateRange] = useState(defaultRange);
  const queryDateRange = {
    startDate: moment(dateRange.startDate).format(DateFormats.QueryFormat),
    endDate: moment(dateRange.endDate).format(DateFormats.QueryFormat)
  };

  const handleDateRangeChange = selectedDateRange => setDateRange(selectedDateRange);

  return (
    <Widget
      header={COPIES.title}
      promises={[
        () =>
          getActivityPlacementsHistory({
            groupBy: 'recruiter',
            ...queryDateRange,
            ...requestParams
          })
      ]}
    >
      {([response]) => {
        const data = formatResponse(response);

        return (
          <>
            <DateRange
              DateRangerPickerProps={{
                staticRanges: createCustomStaticRanges(additionalPeriodRanges)
              }}
              defaultRange={dateRange}
              disableTimeRange
              onPeriodChange={handleDateRangeChange}
            />
            <LineSteppedAreaChart data={data} />
          </>
        );
      }}
    </Widget>
  );
};
